export const sseUrls = {
  sseTaskUpdate: "/sse/task-update",
};
